<template>
    <div class="form-item">
        <label class="label-caption">Situação</label>
        <select :value="statusSelecionado" @change="atualizarTipo" class="form-control" v-bind="$attrs">
            <option v-for="tipo in lsTipos" :key="tipo.id" :value="tipo.id">{{ tipo.descricao }}</option>
        </select>
    </div>
</template>
  
<script>
export default {
    props: {
        statusSelecionado: {type: String, default: null}
    },

    data() {
        return{
            lsTipos:[
                {id: '', descricao: 'TODOS'},
                {id: 'S', descricao: 'ATIVOS'},
                {id: 'N', descricao: 'INATIVOS'},
            ]
        };
    },

    methods: {
        atualizarTipo(event) {
            this.$emit('update:statusSelecionado', event.target.value);
        }
    }
};
</script>